// Module
var code = "<react-component name=\"ManageWebsiteContactUsCopy\" props=\"{save: save, data: website}\"></react-component>\n";
// Exports
module.exports = code;